import { render, staticRenderFns } from "./ConfirmationGuide.vue?vue&type=template&id=19ec1a56&scoped=true"
import script from "./ConfirmationGuide.vue?vue&type=script&lang=js"
export * from "./ConfirmationGuide.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationGuide.vue?vue&type=style&index=0&id=19ec1a56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec1a56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ec1a56')) {
      api.createRecord('19ec1a56', component.options)
    } else {
      api.reload('19ec1a56', component.options)
    }
    module.hot.accept("./ConfirmationGuide.vue?vue&type=template&id=19ec1a56&scoped=true", function () {
      api.rerender('19ec1a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/confirmation/Components/ConfirmationGuide.vue"
export default component.exports